// Single source of truth for which build variant is compiling.
//
// WHY two builds exist: the same React codebase ships as (1) the public website
// via `npm run build` and (2) the bundle loaded inside the Capacitor iOS/Android
// shell via `npm run build:app`. The app build must NOT carry marketing pages,
// product analytics/ad trackers, or the admin console — see F4.2a.
//
// The "build:app" script sets REACT_APP_BUILD_TARGET=app (via cross-env). CRA/CRACO
// inlines every REACT_APP_* var at compile time (webpack DefinePlugin), so the
// comparison below is fixed at build time and IS_APP_BUILD holds a constant value:
// `false` in the web build, `true` in the app build.
//
// What that does NOT mean (verified in F4.2b §6): IS_APP_BUILD is a cross-module
// const import, and the minifier does NOT fold it into the modules that import it.
// No dead-code elimination happens on `if (IS_APP_BUILD)` branches — BOTH bundles
// carry the other variant's code, shipped inert. The guards are real runtime
// checks that are guaranteed no-ops for the wrong variant. What the web build
// preserves is its BEHAVIOR (identical to before the flag existed), not its bytes.
//
// Read the flag ONLY from here — never sprinkle process.env.REACT_APP_BUILD_TARGET
// around the codebase.
export const IS_APP_BUILD = process.env.REACT_APP_BUILD_TARGET === 'app';
